import { render } from "./market-trends.vue?vue&type=template&id=524c9a2a"
import script from "./market-trends.js?vue&type=script&lang=js"
export * from "./market-trends.js?vue&type=script&lang=js"

import "./market-trends.vue?vue&type=style&index=0&id=524c9a2a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__